<script lang="ts">
import Vue from 'vue'
import BaseModal from "@/components/ui/BaseModal.vue";
// import tariffMixin from "@/views/insuranceProducts/mixins/tariffMixin";
import { updateTariff } from "@/api/tariff"


export default Vue.extend({
    name: "TariffSetting",
    components: {BaseModal},
    model: {
        prop: 'item',
        event: 'change',
    },
    props: {
        item: {
            type: Object,
        },
        hideDiscount: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            visible: false,
            errorMessage: null,
            errorField: null,
            localItem: {},
        }
    },
    computed: {
        isUserLanding() {
            const landingUser = this.$store.getters.USER_TYPES.find(user => user.key === 'landing');
            const landingId = landingUser ? landingUser.id : null;
            return this.item.userType === landingId;
        },
        isUserApi() {
            const apiUser = this.$store.getters.USER_TYPES.find(user => user.key === 'api');
            const apiId = apiUser ? apiUser.id : null;
            return this.item.userType === apiId;
        },
        canEditDiscount() {
            if (this.isUserLanding) {
                return false;
            }
            return !this.hideDiscount && this.item.discount !== undefined;
        },
        canEdit() {
            if (this.isUserLanding || this.isUserApi) {
                return this.canEditDiscount;
            }
            return true;
        }
    },
    // mixins: [tariffMixin],
    watch: {
        item: {
            handler: function(val) {
                this.localItem = {...val}

                if (!val.parentCommission) {
                    this.localItem.gap = 0
                }
            },
            deep: true
        }
    },
    methods: {
        updateTariff(item) {
            updateTariff(item.id, item).then(() => {
                this.$message.success('Тариф змінений')
                if (item.parentCommission && !this.isUserLanding) {
                    item.commission = item.parentCommission - item.gap

                    this.$emit('change', this.localItem)
                } else {
                    this.$emit('change', item)
                }
                this.visible = false
            }).catch(error => {
                this.errorMessage = error.response.data.message
                this.errorField = error.response.data.field || 'all'
                // this.$message.error(error.response.data.message)
            })
        },
        cancel() {
            // this.item.gap = this.localItem.gap
            this.visible = false
        },
        formatNumber(value) {
            if (value === null || value === undefined || value === '') return '';
            return Number(Number(value).toFixed(2));
        },
        limitDecimals(event, field) {
            this.errorMessage = null;
            this.errorField = null;
            let value = event.target.value;
            if (value && value.includes('.')) {
                let parts = value.split('.');
                if (parts[1].length > 2) {
                    let newValue = parseFloat(parts[0] + '.' + parts[1].substring(0, 2));
                    if (field === 'discount') {
                        this.localItem.discount = newValue;
                        event.target.value = newValue;
                    } else if (field === 'gap') {
                        this.localItem.gap = newValue;
                        event.target.value = newValue;
                    }
                }
            }
        }
    },
    created() {
        this.localItem = {...this.item}

        if (!this.item.parentCommission) {
            this.localItem.gap = 0
        }
    }
})
</script>

<template>
<div class="tariff-setting">
    <div v-if="isUserLanding" @click="canEdit ? visible = !visible : null" class="d-flex gap-8" :style="!canEdit ? 'cursor: default' : ''">
        <div class="commission border-none" :style="!canEdit ? 'cursor: default' : ''">{{ formatNumber(item.commission) }}</div>
        <div v-if="canEditDiscount" class="discount" :style="!canEdit ? 'cursor: default' : ''">{{ formatNumber(item.discount) }}</div>
    </div>
    <div v-else-if="isUserApi" @click="canEdit ? visible = !visible : null" class="d-flex gap-8" :style="!canEdit ? 'cursor: default' : ''">
        <div class="commission border-none" :style="!canEdit ? 'cursor: default' : ''">{{ formatNumber(item.commission) }}</div>
        <div v-if="canEditDiscount" class="discount" :style="!canEdit ? 'cursor: default' : ''">{{ formatNumber(item.discount) }}</div>
    </div>
    <div v-else @click="visible = !visible">
        <slot name="button"><div class="commission">{{ formatNumber(item.commission) }}</div></slot>
    </div>
<!--    <div @click="visible = !visible" class="d-flex gap-4">-->
<!--        <slot name="button"><div class="commission">{{ item.commission - item.gap }}</div></slot>-->
<!--        <div v-if="item.discount" class="commission">{{ item.discount }}</div>-->
<!--    </div>-->
    <BaseModal v-model="visible">
        <div class="title">
            <slot></slot>
        </div>
        <div v-if="isUserLanding && !hideDiscount && item.discount !== undefined" class="text-center mt-2">
            <div class="mb-2">Вкажіть ваш відсоток знижки</div>
<!--            :class="{'is-invalid': hasError('apartment') }"-->
            <input v-model="localItem.discount" type="number" step="0.01" class="form-control mb-1" :class="{'is-invalid': errorMessage && (errorField === 'discount' || errorField === 'all') }" @input="limitDecimals($event, 'discount')">
            <div class="invalid-feedback d-block" v-if="errorMessage && (errorField === 'discount' || errorField === 'all')">{{ errorMessage }}</div>
        </div>
        <div v-else-if="!isUserLanding" class="text-center mt-2">
            <template v-if="!isUserApi">
                <div class="mb-2">Вкажіть ваш відсоток комісії (зазор)</div>
                <!--            :class="{'is-invalid': hasError('apartment') }"-->
                <input v-model="localItem.gap" type="number" step="0.01" class="form-control mb-1" :class="{'is-invalid': errorMessage && (errorField === 'gap' || errorField === 'all') }" @input="limitDecimals($event, 'gap')">
                <div class="invalid-feedback d-block" v-if="errorMessage && (errorField === 'gap' || errorField === 'all')">{{ errorMessage }}</div>
                <span>Це частка від кожного продажу, яку ви, як головний агент, залишаєте собі.</span>
            </template>

            <template v-if="isUserApi && !hideDiscount && item.discount !== undefined">
                <div class="mb-2 mt-3">Вкажіть ваш відсоток знижки</div>
                <input v-model="localItem.discount" type="number" step="0.01" class="form-control mb-1" :class="{'is-invalid': errorMessage && (errorField === 'discount' || errorField === 'all') }" @input="limitDecimals($event, 'discount')">
                <div class="invalid-feedback d-block" v-if="errorMessage && (errorField === 'discount' || errorField === 'all')">{{ errorMessage }}</div>
            </template>
        </div>
        <div class="footer">
          <button class="btn btn-primary w-100" @click="updateTariff(localItem)">Застосувати</button>
          <button class="btn btn-grey w-100" @click="cancel">Повернутися назад</button>
        </div>
    </BaseModal>
</div>
</template>

<style scoped lang="scss">
.tariff-setting {
    .commission {
        /* _Checkbox base */
        box-sizing: border-box;
        cursor: pointer;

        min-width: 32px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        padding: 2px 8px;
        white-space: nowrap;
        /* Gray/300 */
        border: 1px solid #D5D7DA;
        border-radius: 6px;
        text-align: center;
    }
    .border-none {
        border: unset !important;
        cursor: default !important;
    }
    .discount {
        box-sizing: border-box;
        cursor: pointer;

        min-width: 32px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        padding: 2px 8px;
        white-space: nowrap;
        width: min-content;
        height: 21px;
        /* Gray/300 */
        border: 1px solid #D5D7DA;
        border-radius: 6px;
        text-align: center;
    }
    .content {
        .form-control {
            width: fit-content;
            text-align: center;
            margin: 0 auto;
        }
        width: 80%;
        .title {
            font-family: 'Geist',serif;
            font-style: normal;
            font-weight: 500;
            font-size: 24px;
            line-height: 28px;
            /* identical to box height, or 117% */
            text-align: center;

            color: #09090B;
        }
        span {
            /* Text-xs/Medium */
            font-family: 'Geist',serif;
            font-style: normal;
            font-weight: 500;
            font-size: 12px;
            line-height: 16px;
            /* identical to box height, or 133% */
            color: #717680;
            /* Inside auto layout */
            flex: none;
            order: 0;
            flex-grow: 0;
        }
        .footer {
            .btn {
                margin-bottom: 17px;
            }
            @media (min-width: 768px) {
                display: flex;
                gap: 18px;
                margin-top: 36px;
            }
        }
    }
}
</style>
